module.exports = function getResource(label, vars = []) {
    let resources = {
        addFullSize: 'Add Full Size',
        addToBasket: 'Add to Basket',
        add: 'Add',
        remove: 'Remove',
        viewLarger: 'View Larger'
    };

    return resources[label];
};
